type Field = {
  id: number,
  measurementId?: number,
  /** Id de la fila InspectionValue ya persistida (solo mediciones) — se usa
   * para el update in-line contra /api/v1/InspectionValue/{id}/update, que
   * es distinto del id de la medición/plantilla (`id`). */
  inspectionValueId?: number,
  key: string
  label: string
  value: string
  isInSpec?: boolean
  inputType: 'input' | 'checkbox' | 'calculated' | 'select' //cuando no es ni decimal, boolean, string
  dataType?: 'decimal' | 'boolean' | 'string' | 'pauseReason' | 'snapshot' //pauseReason, agregar las entidades que se necesiten
  lowerLimit?: number | null
  upperLimit?: number | null
  required: boolean
  validationRules: string | null
  helpText: string | null
  displayOrder: number
  rules?: string,
  catalog?: string
  options?: { label: string; value: string }[]
}

export function useInspectionFormBuilder(template: any) {

  const attributeFields: Field[] = []
  const measurementFields: Field[] = []
  const requirementFields: Field[] = []

  if(!template?.inspectionAttributeTemplate && !template?.inspectionMeasurements && !template?.inspectionAttributeTemplatesV2)
  {
    return { attributeFields:[], measurementFields:[], requirementFields:[] }
  }

  // ---------- ATTRIBUTES ----------
  if(template.inspectionAttributeTemplate)
  {
    for (const attr of template.inspectionAttributeTemplate) {
      if (attr.isDeleted!= undefined && attr.isDeleted==true)
        continue;
      if ( attr.dataType != 'decimal' && attr.dataType != 'string' && attr.dataType != 'boolean' && attr.dataType != 'snapshot' )
      {
        attributeFields.push({
          id: attr.id,
          key: attr.attributeKey,
          value: attr.attributeValue || '-1',
          label: attr.attributeLabel,
          inputType: 'select',
          catalog: attr.dataType, // Example: pauseReasons
          dataType: attr.datatype, // pauseReasons
          required: attr.isRequired,
          displayOrder: attr.displayOrder ?? 0,
          validationRules: attr.validationRules ?? null,
          helpText: attr.helpText,
        })
      }
      else if ( attr.dataType == 'decimal' ||
                attr.dataType == 'string'  ||
                attr.dataType == 'boolean' ||
                attr.dataType == 'snapshot' )
      {
        attributeFields.push({
          id: attr.id,
          key: attr.attributeKey,
          value: attr.attributeValue ?? (
            (attr.dataType === 'boolean') ? '0' : ''
          ),
          label: attr.attributeLabel,
          inputType: (attr.dataType === 'boolean' ? 'checkbox' : 'input'),
          dataType: attr.dataType,
          required: attr.isRequired,
          displayOrder: attr.displayOrder ?? 0,
          validationRules: attr.validationRules  ?? null,
          helpText: attr.helpText,
        })
      }
    }
  }
  // ---------- MEASUREMENTS ----------
  
  if(template.inspectionMeasurements) {
    for (const m of template.inspectionMeasurements) {
      if ((m.isDeleted!= undefined && m.isDeleted==true))
        continue;
      const spectype = m.measurement.specType?.toLowerCase()
      const dataType = m.measurement.datatype?.toLowerCase() //todo:cambiar a m.measurement.dataType
      
      measurementFields.push({
        id: m.id,
        measurementId: m.measurementId,
        inspectionValueId: m.inspectionValue?.id,
        key: `measurement_${m.id}`,
        // El valor medido llega como numero; el formulario trabaja con texto.
        value: m.inspectionValue?.measuredValue != null
          ? String(m.inspectionValue.measuredValue)
          : ((spectype === 'checkbox') ? '0' : ''),
        ...((m.inspectionValue?.isInSpec != undefined && {isInSpec: m.inspectionValue?.isInSpec})),
        label: (spectype === 'checkbox')  ? m.measurement.name : m.measurement.name + ' | ' + m.name,
        inputType: spectype, 
        dataType: dataType,
        lowerLimit: null,
        upperLimit: null,
        required: m.isRequired,
        displayOrder: m.displayOrder ?? 0,
        validationRules: null,
        helpText: null,
      })
    }
  }

  // ---------- REQUIREMENTS ----------
  if(template.inspectionAttributeTemplatesV2) {
    for (const attr of template.inspectionAttributeTemplatesV2) {
      if (attr.isDeleted!= undefined && attr.isDeleted==true)
        continue;
      const datatype = attr.dataType.toLowerCase();
      if ( datatype != 'decimal' && datatype != 'string' &&  datatype != 'boolean' && datatype != 'snapshot' )
      {
        requirementFields.push({
          id: attr.id,
          key: attr.attributeKey,
          value: attr.attributeValue || '-1',
          label: attr.attributeLabel,
          inputType: 'select',
          catalog: datatype, // pauseReasons
          dataType: datatype, // pauseReasons
          required: attr.isRequired,
          displayOrder: attr.displayOrder ?? 0,
          validationRules: attr.validationRules ?? null,
          helpText: attr.helpText,
        })
      }
      else if ( datatype == 'decimal' ||
                datatype == 'string'  ||
                datatype == 'boolean' ||
                datatype == 'snapshot' )
      {
        requirementFields.push({
          id: attr.id,
          key: attr.attributeKey,
          value: attr.attributeValue ?? (
            (datatype === 'boolean') ? '0' : ''
          ),
          label: attr.attributeLabel,
          inputType: (datatype === 'boolean' ? 'checkbox' : 'input'),
          dataType: datatype,
          required: attr.isRequired,
          displayOrder: attr.displayOrder ?? 0,
          validationRules: attr.validationRules  ?? null,
          helpText: attr.helpText,
        })
      }
    }
  }

  // 👇 Aquí viene lo importante: ordenar por displayOrder
  attributeFields.sort((a, b) => a.displayOrder - b.displayOrder)
  measurementFields.sort((a, b) => a.displayOrder - b.displayOrder)
  requirementFields.sort((a, b) => a.displayOrder - b.displayOrder)

  return {
    attributeFields,
    measurementFields,
    requirementFields
  }
}
